import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './profile.html',
  styleUrl: './profile.css',
})
export class Profile implements OnInit {

  fullName = '';
  email = '';
  phone = '';
  address = '';

  loading = true;

  apiUrl = 'https://superbangladesh-api-1.onrender.com';

  private readonly isBrowser: boolean;

  constructor(
    private http: HttpClient,
    public languageService: LanguageService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  t(key: string): string {
    return this.languageService.translate(key);
  }

  // =========================================================
  // 🔒 SSR FIX: token শুধু browser-এর localStorage-এ থাকে, তাই
  // server-side render-এ এই authenticated call করার কোনো মানে
  // নেই (token ছাড়া হয় 401 আসতো, নাহলে Angular-এর HTTP transfer
  // cache সেই খালি/আনঅথেন্টিকেটেড response-টাই client-এ replay
  // করে দিতো — আসল লগইন করা user-এর ডেটা আর কখনো fetch হতো না)।
  // এখন শুধু browser-এ hydrate হওয়ার পরই real request পাঠানো হয়,
  // যেটা page load হলে সাথে সাথেই ঘটে (তাই ইউজার কোনো delay টের
  // পাবে না) — কিন্তু আগের মতো "loading-এ আটকে থাকা" bug আর হবে না।
  // =========================================================
  ngOnInit(): void {

    if (!this.isBrowser) {
      return;
    }

    this.loadProfile();
  }

  getHeaders(): HttpHeaders {

    const token = this.isBrowser
      ? (localStorage.getItem('token') || '')
      : '';

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

  }

  loadProfile(): void {

    this.http.get<any>(
      `${this.apiUrl}/api/users/profile`,
      {
        headers: this.getHeaders()
      }
    ).subscribe({

      next: (user) => {

        this.fullName = user.fullName || '';
        this.email = user.email || '';
        this.phone = user.phone || '';
        this.address = user.address || '';

        this.loading = false;

        // ⚠️ ZONELESS FIX: এই অ্যাপে zone.js নেই, তাই HttpClient
        // response আসার পরে plain field (this.loading) বদলালেও
        // Angular নিজে থেকে re-render করে না — যতক্ষণ না কোনো
        // click-এর মতো Angular-tracked event CD চালায়। এই কারণেই
        // প্রোফাইল পেজ "Loading..." এ আটকে থাকতো, আর reload/click
        // করলেই ঠিক হয়ে যেত। markForCheck() দিয়ে response আসামাত্রই
        // re-render বাধ্য করা হলো (navbar.ts-এর একই fix অনুসরণ করে)।
        this.cdr.markForCheck();

      },

      error: (err) => {
        console.error(err);
        this.loading = false;
        this.cdr.markForCheck();
      }

    });

  }

  saveProfile(): void {

    this.http.put<any>(
      `${this.apiUrl}/api/users/profile`,
      {
        fullName: this.fullName,
        phone: this.phone,
        address: this.address
      },
      {
        headers: this.getHeaders()
      }
    ).subscribe({

      next: () => {

        alert(this.t('profileUpdatedSuccess'));

      },

      error: (err) => {

        console.error(err);
        alert(this.t('profileUpdateFailed'));

      }

    });

  }

}
